import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary-blue rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">GE</span>
              </div>
              <span className="text-lg font-semibold font-heading">germanexposolutions</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@germanexposolutions.com" className="hover:text-white transition-colors">
                  info@germanexposolutions.com
                </a>
              </div>
              <div className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4" />
                <a href="tel:004917663322899" className="hover:text-white transition-colors">
                  +49 176 633 22 899
                </a>
              </div>
              <div className="flex items-center gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4" />
                <span>Koblenz, Germany</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-white">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-home">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-about">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-services">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-how-it-works">
                  {t('nav.howItWorks')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-contact">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-white">{t('footer.legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/imprint" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-imprint">
                  {t('footer.imprint')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-link-privacy">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} germanexposolutions. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};
